export default __webpack_public_path__ + "static/task1-098377ba1ca359bf53248f0c3c527b8e.webp";